/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {

    "use strict";

    import ILocation = DealerwareWebServices.ILocation;

    export class LocationsController {

        public static $inject : string[] = [
            '$state',
            '$mdDialog',
            '$dealerwareNotification',
            'LocationPersistenceService',
            'LocationFactory'
        ];

        public modal: any;
        public selectedLocation: ILocation;
        public locationsLoaded: boolean = false;

        constructor(
            public $state: any,
            public $mdDialog: any,
            public $dealerwareNotification: any,
            public LocationPersistenceService: any,
            public LocationFactory: any
        ) {
            this.LocationPersistenceService.clear();

            this.selectedLocation = this.LocationFactory.getInstance();
        }

        public locationSelected (location: any) : void {

            this.selectedLocation.create (location.data);

            this.$state.go(
                'root.private.application.locations.location.summary',
                { locationId: location.data.id }
            );
        }
    }

    getDealerwareWebContentModule().controller(
        'LocationsController', LocationsController
    );

}
